const $ = require('jquery')
// require ('imports-loader?jQuery=>window.jQuery!./script.js')
require ('./plugins.js')

// const $ = window.jQuery;

import init from './form'
import * as forms from './script'

window.addEventListener('load', function(){
  // Initialize upload forms
  init(document.getElementById('metadataform'))


  // Initialize other forms
  var discovery_form = $('form.discovery');
  var chambers_form = $('form.order_chambers_transcript'); 
  var appeal_book_form = $('form.order_appeal_books'); 
  var boardroom_form = $('form.boardroom');

  if(discovery_form.length){
      $('input[name=date]').datepicker({dateFormat:'yy-mm-dd'});
      forms.enable_discovery_form(discovery_form);
  }

  if(boardroom_form.length){
      $('input[name=date]').datepicker({dateFormat:'yy-mm-dd'});
      forms.enable_boardroom_form(boardroom_form);
  }

  if(chambers_form.length){
      forms.enable_chambers_form(chambers_form);
  }

  if(appeal_book_form.length){
      forms.enable_appeal_books_form(appeal_book_form);
  }


  // Initialize assorted other bits
  $('.not-applicable').change(function(){
    $(this)
      .closest('li')
      .find('input[type=text]')
      .attr('disabled', $(this).is(':checked'));
  });


  $('.feedback-form').hide();

  $('.feedback.button').click(function(e){
      e.preventDefault();
      $('.feedback-form').slideToggle();
      return false;
  });

  $('input.date').datepicker({dateFormat:'yy-mm-dd'});
  $('input.dateISO').datepicker({dateFormat:'yy-mm-dd'});
})



// WEBPACK FOOTER //
// ./src/index.js